import React from 'react'
import {KitDescWrapper, KitTitle, KitDescText, KitButton, ArrowRight} from '../style'

export const KitDesc = ({id, section}) =>  {
    const titles = section.title.map((data) => {
        return(<KitTitle key={data.id} {...data}>{data.text}</KitTitle>)
    })

    return (
        <>
        <KitDescWrapper>
            <div>{titles}</div>
            <KitDescText {...section.description}>
                {section.description.text}
            </KitDescText>
            <KitButton to={"/"+id+"Details"} {...section.button}>{section.button.text}{(section.button.arrow==='true') ? <ArrowRight/> : ''}</KitButton>
            
        </KitDescWrapper>
        </>
    )
}
